import React from 'react'
import { connect } from 'react-redux'
import { Grid, Segment } from 'semantic-ui-react'
import { LKDate } from 'loankeeper-common/helpers/Date'
//@ts-ignore
import LKButton from 'shared/LKButton'
//@ts-ignore
import LKGrid from 'shared/LKGrid'
import { deleteClientMonitoring } from '../../../store/client'
//@ts-ignore
import { SegmentGroup, FlexTableChild, GridContainer } from 'shared/StyledComponents'
import { withUserConfig } from 'shared'
//@ts-ignore
import withConstantPermissions from 'shared/containers/withConstantPermissions'
import { translateBase as translate, translateLKMessage, icon } from '../helpers'
import { constants as DCConstants, actions as DCActions } from '../../DetailsContainer'
import ClientMonitoringForm, { open } from '../../ClientMonitoringForm'
import { MonitoringProps, monitoring } from '../types'

const LKGridConfig = {
  gridIdentity: {
    formName: 'frm_client_view',
    objectName: 'dbgrd_mon',
  },

  // columnDefs: [
  //   { headerName: 'SDate', field: 'SDate' },
  //   { headerName: 'MType', field: 'MType' },
  //   { headerName: 'SEC_UserID', field: 'SEC_UserID' },
  //   { headerName: 'Comment', field: 'Comment' },
  // ],

  syncGridState: true,
  enableColumnsResize: true,
  enableColumnsOrder: true,
  enableRowSelection: true,

  columnConfigs: {
    SDate: {
      valueFormatter: ({ value }) => LKDate.from(value).toString(),
    },
  },
}

@withConstantPermissions()
@withUserConfig(['ID as UserID'])
//@ts-ignore
@connect(undefined, {
  open,
  fetchPage: (ID: string, hash: string) =>
    DCActions.fetchPage({
      type: 'Client',
      ID,
      hash,
      page: 'monitoring',
      permission: 'CLIENT_MONITORING_VIEW',
    }),
  deleteClientMonitoring,
})
class Monitoring extends React.Component<MonitoringProps> {
  getContextMenuItems = ({ node: { data } }: { node: { data: monitoring } }) => {
    return this.props.data.base.IsArrested !== 1 &&
      (data.SEC_UserID === this.props.UserID || this.props.permissions.CLIENT_MONITORING_DELETE_ALIEN)
      ? [
          {
            name: translate('cmd_mon_edit'),
            icon: 'edit',
            action: () => this.props.open({ data }),
            permissionKey: 'CLIENT_MONITORING_EDIT',
          },

          {
            name: translate('cmd_mon_delete'),
            icon: 'delete',
            action: () =>
              this.props
                .deleteClientMonitoring({
                  ID: data.ID,
                  HashSum_ClientMonID_: data.HashSum_ClientMonID_,
                  ClientID: this.props.ID,
                  HashSum_ClientID_: this.props.hash,
                })
                .then(() => this.props.fetchPage(this.props.ID, this.props.hash)),
            confirmModalConfig: { message: translateLKMessage('CONFIRM_MONITORING_DELETE') },
            permissionKey: 'CLIENT_MONITORING_DELETE',
          },
        ]
      : []
  }

  handleAdd = () => this.props.open()

  render() {
    const {
      ID,
      hash,
      data: { monitoring, base, linkedfiles },
    } = this.props
    return (
      <SegmentGroup>
        <Segment.Group>
          <FlexTableChild>
            <LKGrid
              instanceName={`${DCConstants.DetailsGridPrefixes.loan}-${ID}-Monitoring`}
              rowData={monitoring}
              {...LKGridConfig}
              getContextMenuItems={this.getContextMenuItems}
            />
          </FlexTableChild>

          <ClientMonitoringForm ClientID={ID} ClientHash={hash} linkedfiles={linkedfiles} />

          {base.IsArrested !== 1 && (
            <Segment>
              <GridContainer>
                <Grid>
                  <Grid.Row>
                    <Grid.Column>
                      <LKButton alias="add" onClick={this.handleAdd} permission="CLIENT_MONITORING_ADD">
                        {translate('cmd_mon_add')}
                      </LKButton>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </GridContainer>
            </Segment>
          )}
        </Segment.Group>
      </SegmentGroup>
    )
  }
}

//@ts-ignore
Monitoring.config = {
  title: () => translate('tb_monitoring'),
  name: 'monitoring',
  component: Monitoring,
  api: [{ page: 'monitoring', permission: 'CLIENT_MONITORING_VIEW' }, 'base', 'linkedfiles'],
  icon: icon('tb_monitoring'),
}
//@ts-ignore
Monitoring.defaultProps = {
  data: [],
}

export default Monitoring
